module.exports = __webpack_public_path__ + "static/media/bg-cover-1.13eac3b1.png";